var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMailIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6D3705",
  d: "M9 8H1a1 1 0 0 1-1-1V.957A1 1 0 0 1 1 0h8a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1M1 1.934V7h8V1.934L5 4.6zM1.4 1 5 3.4 8.6 1z"
})));
export default SvgMailIcon;